import { SEARCH_SUCCESS } from "./const";

const action = (result, updateType = "replace") => {
  return {
    type: SEARCH_SUCCESS,
    result,
    updateType,
  };
};

export default action;
